// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
    padding-top: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .headerBlock {
    display: flex;
    align-items: center;
  }
  .header__text {
    display: flex;
    flex-direction: column;
    margin-left: 25px;
  }
  .header__title {
    color: #000000;
    font-family: "Open Sans";
    font-size: 28px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 65px;
    margin: 0;
  }
  .header__info {
    color: #000000;
    font-family: "Open Sans";
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0;
    line-height: 24px;
    margin-top: 4px;
  }
  .switcher {
    display: flex;
    align-items: end;
  }
  
  .switcher__icon {
    border-radius: 50px;
    border: 4px solid #A3A7A8;
    background: linear-gradient(108deg, #FFF -3.63%, rgba(255, 255, 255, 0) 196.93%);
    width: 32px;
    height: 16px;
    position: relative;
    margin: 0 15px;
    cursor: pointer;
  }
  
  .switcher__icon .icon__ball {
    transition: all 0.2s;
    position: absolute;
    top: 2px;
    left: 3px;
    width: 13px;
    height: 13px;
    flex-shrink: 0;
    border-radius: 50%;
    background: linear-gradient(213deg, #6f6f6f -3.63%, rgba(255, 255, 255, 0) 196.93%);
  }
  
  .switcher__icon.active {
    background: linear-gradient(213deg, #fff -3.63%, rgba(255, 255, 255, 0) 196.93%);
  }
  
  .switcher__icon.active .icon__ball {
    transform: translateX(13px);
  }
  
  @media screen and (max-width: 768px) {
    .switcher__icon {
      width: 50px;
      height: 30px;
      margin: 0 10px;
    }
  
    .switcher__icon.active .icon__ball {
      transform: translateX(16px);
    }
  
    .switcher__icon .icon__ball {
      width: 20px;
      height: 20px;
    }
  }
.header__mode{
  color: #000000;
  font-family: "Open Sans";
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 24px;
  text-transform: uppercase;
  width: 120px;
  height: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;EACA;IACE,aAAa;IACb,mBAAmB;EACrB;EACA;IACE,aAAa;IACb,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,cAAc;IACd,wBAAwB;IACxB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,SAAS;EACX;EACA;IACE,cAAc;IACd,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;EACjB;EACA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;IACnB,yBAAyB;IACzB,gFAAgF;IAChF,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,cAAc;IACd,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,mFAAmF;EACrF;;EAEA;IACE,gFAAgF;EAClF;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE;MACE,WAAW;MACX,YAAY;MACZ,cAAc;IAChB;;IAEA;MACE,2BAA2B;IAC7B;;IAEA;MACE,WAAW;MACX,YAAY;IACd;EACF;AACF;EACE,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,WAAW;AACb","sourcesContent":[".header {\n    padding-top: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n  .headerBlock {\n    display: flex;\n    align-items: center;\n  }\n  .header__text {\n    display: flex;\n    flex-direction: column;\n    margin-left: 25px;\n  }\n  .header__title {\n    color: #000000;\n    font-family: \"Open Sans\";\n    font-size: 28px;\n    font-weight: bold;\n    letter-spacing: 0;\n    line-height: 65px;\n    margin: 0;\n  }\n  .header__info {\n    color: #000000;\n    font-family: \"Open Sans\";\n    font-size: 18px;\n    font-weight: 500;\n    letter-spacing: 0;\n    line-height: 24px;\n    margin-top: 4px;\n  }\n  .switcher {\n    display: flex;\n    align-items: end;\n  }\n  \n  .switcher__icon {\n    border-radius: 50px;\n    border: 4px solid #A3A7A8;\n    background: linear-gradient(108deg, #FFF -3.63%, rgba(255, 255, 255, 0) 196.93%);\n    width: 32px;\n    height: 16px;\n    position: relative;\n    margin: 0 15px;\n    cursor: pointer;\n  }\n  \n  .switcher__icon .icon__ball {\n    transition: all 0.2s;\n    position: absolute;\n    top: 2px;\n    left: 3px;\n    width: 13px;\n    height: 13px;\n    flex-shrink: 0;\n    border-radius: 50%;\n    background: linear-gradient(213deg, #6f6f6f -3.63%, rgba(255, 255, 255, 0) 196.93%);\n  }\n  \n  .switcher__icon.active {\n    background: linear-gradient(213deg, #fff -3.63%, rgba(255, 255, 255, 0) 196.93%);\n  }\n  \n  .switcher__icon.active .icon__ball {\n    transform: translateX(13px);\n  }\n  \n  @media screen and (max-width: 768px) {\n    .switcher__icon {\n      width: 50px;\n      height: 30px;\n      margin: 0 10px;\n    }\n  \n    .switcher__icon.active .icon__ball {\n      transform: translateX(16px);\n    }\n  \n    .switcher__icon .icon__ball {\n      width: 20px;\n      height: 20px;\n    }\n  }\n.header__mode{\n  color: #000000;\n  font-family: \"Open Sans\";\n  font-size: 18px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 24px;\n  text-transform: uppercase;\n  width: 120px;\n  height: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
